<template>
    <div>
        
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'Logout',
    methods: mapActions(['logoutUser', 'clearAdminRoom']),
    async created() {
        this.clearAdminRoom();
        await this.logoutUser();
        this.$router.push('/login');
    }
}
</script>